import { combineLatest, Observable, tap } from 'rxjs'

import { latestAuthState$, latestUserCategory$ } from './state'

/**
 * Auth/customer state mirrored onto `<html>` as data attributes (see maintainAuthDomAttributes$)
 * so CSS can react to it - e.g. suppressing the PDP TrueMed banner - without waiting for a React
 * re-render. `Auth0Provider` (and the state these attributes derive from) is mounted once at the
 * app root, so the attributes persist correctly across Gatsby client-side navigation.
 */
export const AUTH_LOADING_DATA_ATTRIBUTE = 'data-auth-loading'
export const AUTHENTICATED_DATA_ATTRIBUTE = 'data-authenticated'
export const USER_CATEGORY_DATA_ATTRIBUTE = 'data-user-category'

const applyAuthDomAttributes = (
  rootElement: HTMLElement,
  {
    isLoading,
    isAuthenticated,
    userCategory,
  }: { isLoading: boolean; isAuthenticated: boolean; userCategory: string | undefined },
) => {
  rootElement.setAttribute(AUTH_LOADING_DATA_ATTRIBUTE, String(isLoading))
  rootElement.setAttribute(AUTHENTICATED_DATA_ATTRIBUTE, String(isAuthenticated))
  if (userCategory) {
    rootElement.setAttribute(USER_CATEGORY_DATA_ATTRIBUTE, userCategory)
  } else {
    rootElement.removeAttribute(USER_CATEGORY_DATA_ATTRIBUTE)
  }
}

export const maintainAuthDomAttributes$: Observable<unknown> = combineLatest([
  latestAuthState$,
  latestUserCategory$,
]).pipe(
  tap(([{ isLoading, isAuthenticated }, userCategory]) => {
    applyAuthDomAttributes(document.documentElement, { isLoading, isAuthenticated, userCategory })
  }),
)
